import type {AssetGalleryAsset} from '@netx/core-asset-gallery/types';
import {type IAsset} from '@netx/core-asset-next/schema';

export const assetExpires = (asset: AssetGalleryAsset | IAsset) =>
	!!asset.expirationDate;
